import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ArrowIcon } from '../icons';

import arrowClasses, { circularArrow } from './scss/CircularArrow.module.scss';

const CircularArrow = ({ type, direction, className, size }) => {
  return (
    <span className={classNames(
      circularArrow, arrowClasses[type], arrowClasses[direction], arrowClasses[size], className
    )}>
    <ArrowIcon />
    </span>
  )
}

CircularArrow.propTypes = {
  type: PropTypes.oneOf(['default', 'primary']),
  direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  size: PropTypes.oneOf(['sm', 'md']),
  className: PropTypes.string
};

CircularArrow.defaultProps = {
  type: 'default',
  direction: 'right',
  size: 'md'
};

export default CircularArrow;